import React from "react";

const LogoImg = () => {
  return (
    <div>
      <svg
        width="80"
        height="80"
        viewBox="0 0 113 121"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_b_4_4)">
          <ellipse cx="56.5" cy="65" rx="56.5" ry="56" fill="#FD7C7B" />
        </g>
        <g filter="url(#filter1_i_4_4)">
          <path
            d="M34.706 97H30.0185L56.2614 24.2727H61.375L87.6179 97H82.9304L58.9957 29.9901H58.6406L34.706 97ZM41.3466 69.6207H76.2898V73.7401H41.3466V69.6207Z"
            fill="#3B625F"
          />
        </g>
        <defs>
          <filter
            id="filter0_b_4_4"
            x="-4"
            y="5"
            width="121"
            height="120"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImage" stdDeviation="2" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_4_4"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_4_4"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_i_4_4"
            x="30.0185"
            y="24.2727"
            width="57.5994"
            height="76.7273"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_4_4"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default LogoImg;
